/* eslint-disable no-shadow */
/* eslint-disable react/button-has-type */
/* eslint-disable consistent-return */
/* eslint-disable no-inner-declarations */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable array-callback-return */
/* eslint-disable use-isnan */
/* eslint-disable vars-on-top */
/* eslint-disable react/prop-types */
/* eslint-disable no-var */
/* eslint-disable camelcase */
/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
import React, { lazy, useState, useEffect, useContext, Suspense, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Row, Col, Spin, Modal, Select, Tag, Alert, Table, Space, message } from 'antd';
import { Switch, Route, Link, useLocation, useHistory, NavLink } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react';
import { useQuery, useSubscription } from '@apollo/react-components';
import { PulseLoader } from 'react-spinners';
import { BlurContainer } from './style';
import { Button } from '../../../buttons/buttons';
// import { CardBarChart2, EChartCard, OverviewSalesCard, MapContainer } from '../../../style';
import { Drawer } from '../../../drawer/drawer';
import { Cards } from '../../../cards/frame/cards-frame';
import { landingPageFilterData, landingPageGetData } from '../../../../redux/chartContent/actionCreator';
import { NOTIFICATION_QUERY } from '../../../../graphql-query/graphql-query';
import Heading from '../../../heading/heading';
import { ChartjsBarChartTransparent } from '../../../charts/chartjs';
import { ReportAnalysisBannerWrapper, BannerWrapper, ReportBanner } from '../../../banners/Style';
import backgroundImage from '../../../../static/img/data_analysis.jpg';
import { UserAuthenticationContext } from '../../../../config/auth/token_provider';
import { setActiveLayoutAction } from '../../../../redux/pricingLayoutDailog/actionCreator';
import { setNotificationGraphData } from '../../../../redux/notification/actionCreator';
import 'dotenv/config';

const ReportCardGrid = lazy(() =>
  import('../../../../container/dashboard/overview/project/overview/DAAS-Report-V2/IndiviualReportCard-2'),
);
const ChatApp = lazy(() => import('../../../../container/chat/overview/singleChat'));

const useWindowDimensions = () => {
  const hasWindow = typeof window !== 'undefined';
  function getWindowDimensions() {
    const width = hasWindow ? window.innerWidth : null;
    const height = hasWindow ? window.innerHeight : null;
    return {
      width,
      height,
    };
  }
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
  useEffect(() => {
    if (hasWindow) {
      function handleResize() {
        setWindowDimensions(getWindowDimensions());
      }
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }
  }, [hasWindow]);
  return windowDimensions;
};

const { Option } = Select;

const NotificationSideBar = () => {
  const location = useLocation();
  const history = useHistory();
  const { user } = useContext(UserAuthenticationContext);
  const [activeEnviornment, setActiveLayoutActionEnviornment] = useState('local');
  const notification = useSelector(state => state.notification);
  const activeLayout = useSelector(state => state.pricingLayoutDailogReducer);
  const [isInteractWithModelActive, toggleViewOfInteractWithModel] = useState(true);
  const [analysisParamValue, setAnalysisValueParam] = useState([]);
  const [analysisStartStatus, setAnalysisStartStatus] = useState(false);
  const [result, setResult] = useState(null);
  const [inputInvalidated, setInputValidation] = useState(false);
  const Symbol = useSelector(state => state.symbolData);
  const mainDailog = useSelector(notificationState => notificationState.pricingLayoutDailogReducer);
  const dispatch = useDispatch();
  const ref = useRef(null);
  const [symbolCode, setSymbolCode] = useState('');
  const { height, width } = useWindowDimensions();
  const [isMobile, setMobileStatus] = useState(false);
  const [showNotificationPanel, toggleNotificationPanel] = useState(false);
  const [showChatbox, toggleChatboxView] = useState(false);
  const pricingDailog = useSelector(state2 => state2.pricingLayoutDailogReducer);
  const notificationData = useSubscription(NOTIFICATION_QUERY, {
    variables: {
      symbol_code: symbolCode,
    },
  });

  useEffect(() => {
    console.log('Notification Data ********** : ', notification);
    console.log('Windows Location : ', window.location.pathname);
    // console.log('Width : ', width);
    // console.log('Height : ', height);
  }, []);

  useEffect(() => {
    // console.log('Width : ', width);
    // console.log('Height : ', height);
  }, [width]);

  useEffect(() => {
    if (notificationData.data && notificationData.data.core_web_notifications) {
      console.log('Notification Data From Notification SideBar Component : ', notificationData);
      console.log('Already Ran Once !');
    }
  }, [notificationData.data]);

  useEffect(() => {
    console.log('Initializing Notification Popover Compoenent !');
    const currentEnviornment =
      process.env && process.env.REACT_APP_ENVIORNMENT === 'production'
        ? 'prod'
        : process.env && process.env.REACT_APP_ENVIORNMENT === 'development'
        ? 'dev'
        : 'local';
    setActiveLayoutActionEnviornment(currentEnviornment);
  }, []);

  useEffect(() => {
    console.log(Symbol);
    console.log('Notification Data 2 : ', notificationData);
    setSymbolCode(Symbol.selectedSymbol.symbolcode);
  }, [Symbol.selectedSymbol]);

  useEffect(() => {
    setAnalysisValueParam([]);
    setResult(null);
    setInputValidation(false);
    if (notification.notificationObject.payload && notification.notificationObject.payload.model_interaction) {
      ref.current.value = '';
    }
    console.log('Updating Status');
  }, [mainDailog.pricingLayout]);

  const generateSingleChart = chartPayload => {
    console.log('Selected Graph : ', chartPayload);
    if (chartPayload && chartPayload.payload) {
      return (
        <ReportCardGrid
          chartPositionIndex={1}
          graphData={chartPayload.payload}
          sectionType={chartPayload.category}
          sectionName={chartPayload.payload.chart_title}
          usedFrom="notification"
          chartHeight={270}
          overflowHidden
          cardHeight={width > 1000 ? 550 : 'auto'}
        />
      );
    }
    return null;
  };

  const getColumnSize = () => {
    if (
      notification.notificationObject &&
      notification.notificationObject.payload &&
      notification.notificationObject.payload.chart_type &&
      notification.notificationObject.category &&
      notification.notificationObject.category !== 'Analyst Note' &&
      width > 800 &&
      isMobile === false
    ) {
      return 17;
    }
    if (width < 800 && showNotificationPanel == false) {
      return 24;
    }
    console.log('Notification Object : ', notification);
    console.log('Column Size Partial Full : ', 24);
    return 24;
  };

  const onClickViewAnalysis = notificationObject => {
    console.log('Updating Notification Status !');
    console.log('Notification Selected Object : ', notificationObject);
    toggleNotificationPanel(false);
    if (notificationObject.payload.chart_type === 'table') {
      dispatch(setActiveLayoutAction('table_chart'));
    } else if (
      (notificationObject.category === 'test' || notificationObject.category === 'Analysis') &&
      notificationObject.payload.model_interaction === false
    ) {
      dispatch(setActiveLayoutAction('analysis_graph'));
    } else {
      dispatch(setActiveLayoutAction('notification'));
    }
    dispatch(setNotificationGraphData(notificationObject));
    console.log('Notification Updated Object : ', notification);
  };

  const changingAnalysisParameterValue = (e, index) => {
    const { name, value } = e.currentTarget;
    var valueSet = analysisParamValue;
    valueSet[index] = Number(value);
    setAnalysisValueParam(valueSet);
    console.log('User Typed : ', valueSet);
  };

  const timeSince = date => {
    const seconds = Math.floor((new Date() - new Date(date)) / 1000);
    let interval = seconds / 31536000;
    if (interval > 1) {
      return `${Math.floor(interval)} years`;
    }
    interval = seconds / 2592000;
    if (interval > 1) {
      return `${Math.floor(interval)} months`;
    }
    interval = seconds / 86400;
    if (interval > 1) {
      return `${Math.floor(interval)} days`;
    }
    interval = seconds / 3600;
    if (interval > 1) {
      return `${Math.floor(interval)} hours`;
    }
    interval = seconds / 60;
    if (interval > 1) {
      return `${Math.floor(interval)} minutes`;
    }
    return `${Math.floor(seconds)} seconds`;
  };

  const startAnalysis = () => {
    setAnalysisStartStatus(true);
    setInputValidation(false);
    var checkIfError = false;
    Object.keys(notification.notificationObject.payload.model_detail.model_input_field).map((x, i) => {
      if (
        analysisParamValue &&
        analysisParamValue[i] !== NaN &&
        analysisParamValue[i] !== null &&
        (analysisParamValue[i] > notification.notificationObject.payload.model_detail.model_input_field[x][1] ||
          analysisParamValue[i] < notification.notificationObject.payload.model_detail.model_input_field[x][0])
      ) {
        message.error('Please Input Value Within Specified Range !');
        setInputValidation(true);
        checkIfError = true;
        setAnalysisStartStatus(false);
      }
    });
    if (checkIfError === false) {
      const requestOptions = {
        method: 'POST',
      };
      fetch(
        `https://projectrelations-dev.azurewebsites.net/api/HttpTrigger1?endpoint=${
          notification.notificationObject.payload.model_detail.model_url
        }&endpoint_payload=${JSON.stringify({ data: analysisParamValue })}&endpoint_token=${
          JSON.parse(user.idTokenClaims.extension_modelServices)[
            notification.notificationObject.payload.model_detail.model_name
          ].token
        }`,
      )
        .then(response => response.json())
        .catch(x => {
          message.error('Error ! Cannot Process Your Request Properly !');
          setResult(null);
          setAnalysisStartStatus(false);
        })
        .then(data => {
          if (data && data.result) {
            setResult(data.result);
          }
          setAnalysisStartStatus(false);
        });
    }
  };

  const clickBackToNotification = () => {
    toggleNotificationPanel(true);
  };

  const checkIfShowNotification = () => {
    if (pricingDailog && pricingDailog.activeLayout !== 'news' && !showNotificationPanel && width < 800) {
      return false;
    }
    return true;
  };

  return (
    <>
      <Button
        onClick={clickBackToNotification}
        type="primary"
        shape="circle"
        style={{ display: checkIfShowNotification() ? 'none' : 'flex', justifyContent: 'evenly', alignItems: 'center' }}
      >
        <FeatherIcon icon="arrow-left" size={22} /> All Notification
      </Button>
      <Row align="center">
        {notification.notificationObject &&
        notification.notificationObject.payload &&
        // notification.notificationObject.payload.chart_type !== 'note' &&
        notification.notificationObject.category !== 'Analyst Note' &&
        width > 800 &&
        isMobile === false ? (
          <Col xxl={7} md={7} sm={7} xs={7}>
            <div style={{ paddingTop: '20px' }}>
              <Cards
                title="Notification List"
                bodyStyle={{
                  maxHeight: '550px',
                  minHeight: '320px',
                  height: '550px',
                  position: 'relative',
                  overflow: 'auto',
                  paddingTop: '10px',
                }}
              >
                {notificationData.data && notificationData.data.core_web_notifications ? (
                  notificationData.data.core_web_notifications
                    .sort((a, b) => {
                      const fa = a.category.toLowerCase();
                      const fb = b.category.toLowerCase();
                      if (fa < fb) {
                        return -1;
                      }
                      if (fa > fb) {
                        return 1;
                      }
                      return 0;
                    })
                    .filter(x => (x.category === 'test' && activeEnviornment !== 'prod') || x.category !== 'test')
                    .map((x, i) => (
                      <>
                        {/* {i == 0 || x.category != notificationData.data.core_web_notifications[i - 1].category ? (
                          <div
                            style={{
                              color: 'black',
                              backgroundColor: 'rgb(237 237 237)',
                              padding: '10px 20px',
                              borderRadius: '25px',
                              width: 'fit-content',
                              fontWeight: '600',
                              marginBottom: '10px',
                            }}
                          >
                            {x.category}
                          </div>
                        ) : (
                          <></>
                        )} */}
                        <div
                          style={{
                            width: '100%',
                            height: 'auto',
                            marginBottom: '15px',
                            cursor: 'pointer',
                          }}
                          onClick={() => onClickViewAnalysis(x)}
                        >
                          <h3
                            style={{
                              cursor: 'pointer',
                              color: 'black',
                              fontSize: '14px',
                              padding: '0px',
                              margin: '0px',
                              fontWeight: '400',
                            }}
                          >
                            {x.title}
                          </h3>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                              marginTop: '10px',
                            }}
                          >
                            <p
                              style={{
                                cursor: 'pointer',
                                color: '#838383',
                                fontSize: '12px',
                                padding: '0px',
                                margin: '0px',
                              }}
                            >
                              {timeSince(x.date)} ago
                            </p>
                            <div>
                              {x.payload && x.payload.tags ? (
                                x.payload.tags.slice(0, 2).map(x => (
                                  <div
                                    style={{
                                      color: '#474747',
                                      backgroundColor: 'rgb(223 234 254)',
                                      padding: '7px 10px',
                                      borderRadius: '25px',
                                      width: 'fit-content',
                                      fontWeight: '500',
                                      marginBottom: '10px',
                                      marginRight: '10px',
                                      display: 'inline',
                                      fontSize: '11px',
                                      textWrap: 'nowrap',
                                    }}
                                  >
                                    {x}
                                  </div>
                                ))
                              ) : (
                                <></>
                              )}
                            </div>
                          </div>
                        </div>
                      </>
                    ))
                ) : (
                  <></>
                )}
              </Cards>
            </div>
          </Col>
        ) : showNotificationPanel === true && width < 800 ? (
          <Col xxl={24} md={24} sm={24} xs={24}>
            <div style={{ paddingTop: '20px' }}>
              <Cards
                title="Notification List"
                bodyStyle={{
                  maxHeight: '550px',
                  minHeight: '320px',
                  height: '550px',
                  position: 'relative',
                  overflow: 'auto',
                  paddingTop: '10px',
                }}
              >
                {notificationData.data && notificationData.data.core_web_notifications ? (
                  notificationData.data.core_web_notifications.map(x => (
                    <div
                      style={{ width: '100%', height: 'auto', marginBottom: '15px', cursor: 'pointer' }}
                      onClick={() => onClickViewAnalysis(x)}
                    >
                      <h3
                        style={{ cursor: 'pointer', color: '#4285f4', fontSize: '14px', padding: '0px', margin: '0px' }}
                      >
                        {x.title}
                      </h3>
                      <p
                        style={{ cursor: 'pointer', color: '#838383', fontSize: '12px', padding: '0px', margin: '0px' }}
                      >
                        {timeSince(x.date)} ago
                      </p>
                    </div>
                  ))
                ) : (
                  <></>
                )}
              </Cards>
            </div>
          </Col>
        ) : (
          <></>
        )}
        <Col
          xxl={getColumnSize()}
          md={getColumnSize()}
          sm={getColumnSize()}
          xs={getColumnSize()}
          style={{ display: showNotificationPanel && width < 800 ? 'none' : 'block' }}
        >
          {isInteractWithModelActive === false ? (
            <div style={{ paddingTop: '20px' }}>
              <Suspense fallback={<div>Loading... </div>}>
                {notification.notificationObject && notification.notificationObject.payload ? (
                  generateSingleChart(notification.notificationObject)
                ) : (
                  <></>
                )}
              </Suspense>
            </div>
          ) : (
            <Row justify="space-evenly" align="middle">
              <Col
                xxl={
                  !showChatbox &&
                  notification.notificationObject &&
                  notification.notificationObject.payload &&
                  notification.notificationObject.payload.chart_type === 'note'
                    ? 23
                    : !showChatbox &&
                      notification.notificationObject &&
                      notification.notificationObject.payload &&
                      notification.notificationObject.payload.chart_type === 'table'
                    ? 16
                    : !showChatbox &&
                      notification.notificationObject &&
                      notification.notificationObject.payload &&
                      notification.notificationObject.payload.chart_type !== 'note' &&
                      notification.notificationObject.payload.model_interaction === true
                    ? 23
                    : showChatbox
                    ? 15
                    : 23
                }
                style={{ paddingTop: '20px' }}
              >
                <Suspense fallback={<div>Loading... </div>}>
                  {notification.notificationObject &&
                  notification.notificationObject.payload &&
                  notification.notificationObject.payload.chart_type !== 'note' ? (
                    generateSingleChart(notification.notificationObject)
                  ) : notification.notificationObject &&
                    notification.notificationObject.payload &&
                    notification.notificationObject.payload.chart_type === 'note' ? (
                    // This Will Render Incase Of Notification
                    <Cards title={notification.notificationObject.payload.chart_title} bodyStyle={{ height: '550px' }}>
                      <h4
                        dangerouslySetInnerHTML={{
                          __html: notification.notificationObject.payload.chart_description.replace(
                            /--/g,
                            '<br /><br />',
                          ),
                        }}
                      />
                    </Cards>
                  ) : (
                    <Cards title={notification.notificationObject.title}>
                      <h4
                        dangerouslySetInnerHTML={{
                          __html: notification.notificationObject.description.replace(/--/g, '<br /><br />'),
                        }}
                      />
                    </Cards>
                  )}
                  {notification.notificationObject.payload?.chat ? (
                    <Button
                      raised
                      type={!showChatbox ? 'primary' : 'danger'}
                      shape="circle"
                      style={{ position: 'absolute', top: '35px', padding: '20px', right: '15px' }}
                      onClick={() => toggleChatboxView(!showChatbox)}
                    >
                      {showChatbox ? 'Close Chat' : 'Analyst Chat'}
                    </Button>
                  ) : (
                    <></>
                  )}
                </Suspense>
              </Col>
              {notification.notificationObject.payload && notification.notificationObject.payload.model_interaction ? (
                <Col xxl={7} style={{ paddingTop: '20px', width: '95%', height: '100%' }}>
                  <Cards size="large" title="Model Input" bodyStyle={{ height: '215px', position: 'relative' }}>
                    <Col xxl={24}>
                      {Object.keys(notification.notificationObject.payload.model_detail.model_input_field).map(
                        (x, i) => (
                          <>
                            <h4
                              style={{
                                padding: '10px',
                                paddingTop: '0px',
                                margin: '0px',
                                fontWeight: '500',
                                color: 'black',
                              }}
                            >
                              {x}
                            </h4>
                            <input
                              style={{
                                width: '100%',
                                outline: 'none',
                                border: inputInvalidated ? '1px solid red' : '1px solid #cecece',
                                borderRadius: '5px',
                                padding: '7px',
                                marginBottom: '15px',
                              }}
                              ref={ref}
                              placeholder={`Enter Value Between ${notification.notificationObject.payload.model_detail.model_input_field[x][1]} & ${notification.notificationObject.payload.model_detail.model_input_field[x][0]}`}
                              onChange={y => changingAnalysisParameterValue(y, i)}
                            />
                            <Button
                              raised
                              type="primary"
                              shape="circle"
                              onClick={startAnalysis}
                              style={{ float: 'right' }}
                            >
                              Run
                            </Button>
                          </>
                        ),
                      )}
                    </Col>
                  </Cards>
                  <Cards
                    size="large"
                    title="Model Output"
                    bodyStyle={{ height: '200px', position: 'relative', overflow: 'auto', paddingTop: '10px' }}
                  >
                    <Col xxl={24}>
                      {analysisStartStatus === true ? (
                        <div className="sd-spin" style={{ height: '200px' }}>
                          <PulseLoader
                            color="#4285f4"
                            loading
                            size={15}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                          />
                        </div>
                      ) : (
                        <BlurContainer>
                          <div
                            className="sd-spin"
                            style={{
                              minHeight: '150px',
                              flexWrap: 'wrap',
                              height: 'fit-content',
                            }}
                          >
                            {result !== null ? (
                              <>
                                {Object.keys(result).map(x => (
                                  <>
                                    <div className="result-cards">
                                      <p className="top-paragraph">{x}</p>
                                      <h1 className="top-quantity">{result[x]}</h1>
                                    </div>
                                  </>
                                ))}
                              </>
                            ) : (
                              <>No Output</>
                            )}
                          </div>
                        </BlurContainer>
                      )}
                    </Col>
                  </Cards>
                </Col>
              ) : (
                <></>
              )}
              {showChatbox && notification.notificationObject.payload?.chat ? (
                <Col
                  xxl={
                    notification.notificationObject &&
                    notification.notificationObject.payload &&
                    notification.notificationObject.payload.chart_type === 'note'
                      ? 8
                      : notification.notificationObject &&
                        notification.notificationObject.payload &&
                        notification.notificationObject.payload.chart_type === 'table'
                      ? 8
                      : notification.notificationObject &&
                        notification.notificationObject.payload &&
                        notification.notificationObject.payload.chart_type !== 'note' &&
                        notification.notificationObject.payload.model_interaction === true
                      ? 8
                      : 8
                  }
                  style={{ paddingTop: '20px' }}
                >
                  <Suspense fallback={<div>Loading... </div>}>
                    <ChatApp />
                  </Suspense>
                </Col>
              ) : (
                <></>
              )}
            </Row>
          )}
        </Col>
      </Row>
    </>
  );
};

export default NotificationSideBar;
